import { TextField, StandardTextFieldProps } from '@mui/material';
import { transparentize, lighten } from 'polished';
import React from 'react';
import styled from 'styled-components';
import { FormPublicDesignFragment } from '../../graphql/fragment/form.public.fragment';

interface Props extends StandardTextFieldProps {
  design: FormPublicDesignFragment;
  onChange: any;
  value: string;
  children?: any;
  name: string;
  id: string;
  error?: any;
  helperText: any;
  type?: string;
  variant: any;
  field?: any;
  // https://stackoverflow.com/questions/49784294/warning-received-false-for-a-non-boolean-attribute-how-do-i-pass-a-boolean-f
  $disableUnderline?: boolean;
  pattern?: string | RegExp;
}

const Field = styled(TextField)<{ design: FormPublicDesignFragment }>`
  ${({ field, design }: { field?: any; design: FormPublicDesignFragment }) =>
    field.type === 'textarea'
      ? `& .MuiInput-root {
  border: 2px solid ${design.colors.answer};
  border-radius: 4px;
  padding: 3px;
  &:hover {
    border-width: 2px;
    border-color: ${lighten(0.2, design.colors.button)};
  }
 }`
      : ''};
  &.MuiTextField-root {
    width: 100%;
    background: transparent;
    margin-bottom: 3vh;
    & .MuiInput-underline {
      color: ${({ design }) => design.colors.answer};
      &:hover::before {
        border-width: 1px;
        border-color: ${({ design }) => lighten(0.2, design.colors.button)};
      }
      &::before {
        border-width: 1px;
        border-color: ${({ design }) => design.colors.question};
      }
      &::after {
        border-width: 1px;
        border-color: ${({ design }) => design.colors.button};
      }
    }
    & .MuiFormHelperText-root.Mui-error {
      color: #e42525;
    }
    & .Mui-error {
      &::after {
        border-color: #e42525;
      }
    }
  }

  & input {
    background: none !important;
    color: ${({ design }) => design.colors.answer};

    ::placeholder {
      color: ${({ design }) => transparentize(0.6, design.colors.answer)};
    }
  }
`;

export const StyledTextareaInput: React.FC<Props> = ({
  children,
  ...props
}) => {
  return <Field {...props}>{children}</Field>;
};
